import React from 'react'
import { Signpost } from 'iconsax-react'
import { useAppSelector } from '@SonarCX/hooks/redux'

import CommonButton from '../CommonButton'
import Dropdown from '@SonarCX/components/atoms/Dropdown'
import TaskStatus from '@SonarCX/components/molecules/RenderOptions/TaskStatus'

import { selectTaskStatus } from '@SonarCX/slices/taskStatus'
import useTaskMultiEdit from '../hooks/useTaskMultiEdit'
import useStyles from '../commonStyles'

const SetStatus: React.FC = () => {
  const { statuses } = useAppSelector(selectTaskStatus)

  const { selected, patchTasks } = useTaskMultiEdit()

  const [value, setValue] = React.useState(null)

  const classes = useStyles()

  const handleClose = React.useCallback(() => {
    setValue(null)
  }, [])

  const handleAccept = React.useCallback(async () => {
    const updates: TaskPatch[] = selected.map(id => ({
      id,
      status_id: value
    }))
    await patchTasks({ updates, message: 'Status updated' })
    handleClose()
  }, [selected, value, patchTasks, handleClose])

  return (
    <CommonButton
      title='Set status'
      Icon={Signpost}
      onAccept={handleAccept}
      onClose={handleClose}
    >
      <div className={classes.content}>
        <div className={classes.title}>Status</div>

        <Dropdown
          options={statuses.map(({ id }) => id)}
          disabledOptions={statuses
            .map(({ id, base_status }) => {
              return base_status === 'completed' ? id : null
            })
            .filter(Boolean)}
          renderOption={id => {
            const opt = statuses.find(s => s.id === id)

            if (opt) {
              return <TaskStatus key={id} opt={opt} />
            }
            return null
          }}
          selected={value}
          onSelect={id => setValue(id)}
          hideAdd
          colour
        >
          <div className={classes.center}>
            <TaskStatus opt={statuses.find(({ id }) => id === value) ?? {}} />
          </div>
        </Dropdown>
      </div>
    </CommonButton>
  )
}

export default SetStatus
